import { combineReducers } from '@reduxjs/toolkit'
import { modalSlice } from './slices/modal.slice'
import { portalReducer } from './slices/portal.slice'
import { userSlice } from './slices/user.slice'
import { authApi } from './apis/auth.api'
import { configApi } from './apis/config.api'
import { tokenDistributionApi } from '../pages/TokenDistribution/services/tokenDistribution.api'

export const rootReducer = combineReducers({
  // Slice Reducers
  [modalSlice.name]: modalSlice.reducer,
  [userSlice.name]: userSlice.reducer,
  portal: portalReducer,
  // Api Reducers -- when adding here also add to ./configureStore.ts
  [authApi.reducerPath]: authApi.reducer,
  [configApi.reducerPath]: configApi.reducer,
  [tokenDistributionApi.reducerPath]: tokenDistributionApi.reducer,
})

export type RootReducerState = ReturnType<typeof rootReducer>
